export const BOOKINGS_RESET_STATE = 'BOOKINGS_RESET_STATE';
export const BOOKINGS_CURRENT_ITEM = 'BOOKINGS_CURRENT_ITEM';

export const BOOKINGS_REQUEST_LOADING = 'BOOKINGS_REQUEST_LOADING';
export const BOOKINGS_REQUEST_SUCCESS = 'BOOKINGS_REQUEST_SUCCESS';
export const BOOKINGS_REQUEST_FAILED = 'BOOKINGS_REQUEST_FAILED';

export const BOOKINGS_CURRENT_ACTION = 'BOOKINGS_CURRENT_ACTION';
export const BOOKINGS_RESET_ACTION = 'BOOKINGS_RESET_ACTION';